

<!-- 
<div class="modal-header align-items-center text-primary pb-1">

</div> -->
<div class="modal-body text-primary pt-2">
	<div class="d-flex mb-3">
		<button type="button" class="modal-close ml-auto order-2" aria-label="Close" (click)="closeModal()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>

		<app-response-message [responseMsg]="responseMsg" *ngIf="responseMsg" class="mr-4 order-1"></app-response-message>
	</div>
	

	<a class="btn btn-primary pill font-weight-bold" [routerLink]="['/account/my-travel-boards/' + this.board.id]" (click)="closeModal()" >View Travel Board</a>

</div>
<!-- <div class="modal-footer">
    
	
</div> -->
